import { FC } from 'react';
import { QcsAutocomplete } from './QcsAutocomplete';
import { getFirstLastNameObj } from '../../../utils/format';
import { InvitedPersonDto } from '@api/models/invitation/InvitedPersonDto';

interface Props {
  multiple?: boolean;
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  persons: InvitedPersonDto[];
  excludeIds?: string[];
  style?: React.CSSProperties;
}

export const InvitationPersonAutocomplete: FC<Props> = ({
  multiple,
  name,
  label,
  disabled,
  required,
  persons,
  excludeIds,
  style
}) => {
  const options = excludeIds
    ? persons.filter((person) => !excludeIds.includes(person.employeeId || person.id || ''))
    : persons;

  const getPersonName = (person: InvitedPersonDto) => {
    return getFirstLastNameObj({
      name: person.name,
      lastName: person.lastName
    });
  };

  return (
    <QcsAutocomplete<InvitedPersonDto>
      style={style}
      multiple={multiple}
      name={name}
      label={label}
      required={required}
      disabled={disabled}
      options={options}
      loading={false}
      loadingError={false}
      loadOptions={() => {}}
      getOptionId={(option) => option.employeeId || ''}
      getOptionName={getPersonName}
      getValueIfNotFound={(option) => option}
    />
  );
};
